var React = require('react');

function YoutubeIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_255","data-name":"Group 255","transform":"translate(-1221 -611)"},[React.createElement("circle",{"id":"Ellipse_2","data-name":"Ellipse 2","cx":"40","cy":"40","r":"40","transform":"translate(1221 611)","fill":"#e01e36","key":0}),React.createElement("path",{"id":"Polygon_1","data-name":"Polygon 1","d":"M15.652,0,31.3,26.667H0Z","transform":"translate(1277.667 636) rotate(90)","fill":"#fff","key":1})]));
}

YoutubeIcon.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80"};

module.exports = YoutubeIcon;

YoutubeIcon.default = YoutubeIcon;
